/**
 * Same-page fragment links scroll rather than rely on the browser.
 *
 * A bare href="#target" only moves the page when the fragment actually
 * changes. Click the hero button, scroll back up, click it again and the
 * browser decides it is already there and does nothing. The buy box is linked
 * from both the announcement bar and the hero, and a shopper reading up and
 * down the page will press them more than once, so the scroll is driven here.
 *
 * Delegated from the document so it covers links rendered by any section,
 * including ones added later from the theme editor.
 */
document.addEventListener('click', (event) => {
  // Something nearer the link already handled it: accordions and tab strips
  // in this theme use fragment hrefs for their own controls.
  if (event.defaultPrevented) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

  const link = event.target.closest?.('a[href^="#"]');
  if (!link) return;

  const id = link.getAttribute('href').slice(1);
  if (!id) return;

  const target = document.getElementById(id);
  if (!target) return;

  event.preventDefault();

  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });

  // Keyboard and screen reader users need the caret to follow the viewport,
  // or the next Tab continues from the link they just left behind.
  if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
  target.focus({ preventScroll: true });

  // Leaves the URL shareable. replaceState rather than a hash assignment,
  // which would hand the jump back to the browser we just took it from.
  if (window.history?.replaceState) {
    window.history.replaceState(null, '', `#${id}`);
  }
});
